const VALUE_PART = 1;

export const getSidebarState = (stateName: string) =>
  document.cookie
    .split('; ')
    .find(row => row.startsWith(`${stateName}=`))
    ?.split('=')[VALUE_PART] === 'true';
